<div class="bolt-container">
  @for (report of reportDetails; track $index) {
    <div class="panel">
      <div
        class="panel-header bolt-row bolt-background-paleGray bolt-justify-content-between bolt-space-inner-wide-xl"
        >
        <div class="bolt-col-10 reports-details">
          <img
            class="product-image"
            src="assets/images/icons/circle-colorized.svg"
            />Losses
          </div>
          <div class="bolt-col-2">
            @if (report.losses.length === 0) {
              <div class="reports-icon">
                <bolt-icon
                  name="checkmark-circle-filled"
                  color="theme-success"
                  ></bolt-icon
                  >&nbsp;&nbsp;Clear
                </div>
              }
              @if (report.losses.length > 0) {
                <div class="reports-icon">
                  <bolt-icon
                    name="exclamation-triangle-filled"
                    color="theme-warning"
                    ></bolt-icon
                    >&nbsp;&nbsp;Adverse
                  </div>
                }
              </div>
            </div>
            @if (report.losses.length > 0) {
              <div
                class="panel-body bolt-space-inner-xl"
                >
                @for (loss of report.losses; track $index) {
                  <div class="bolt-row">
                    <div class="bolt-col-6"><strong>Loss cause</strong></div>
                    <div class="bolt-col-6">{{ loss.cause }}</div>
                    <div class="bolt-col-6"><strong>Loss date</strong></div>
                    <div class="bolt-col-6">{{ loss.date }}</div>
                    <div class="bolt-col-6"><strong>Loss amount</strong></div>
                    <div class="bolt-col-6">{{ loss.amount }}</div>
                    <div class="bolt-col-6"><strong>Catastrophic</strong></div>
                    <div class="bolt-col-6">{{ loss.catastrophe ? 'Yes' : 'No' }}</div>
                    <div class="bolt-col-6"><strong>Weather</strong></div>
                    <div class="bolt-col-6">{{ loss.weather ? 'Yes' : 'No' }}</div>
                    <div class="bolt-col-6"><strong>Subrogated</strong></div>
                    <div class="bolt-col-6">{{ loss.subrogatted ? 'Yes' : 'No' }}</div>
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
